<script lang="ts">import SelectField from '../SelectField/SelectField.svelte';
// Need to use let because invalid and selectedValues are bindable and you cannot bind to a constant and you cannot
// use the $props() rune twice
/* eslint-disable prefer-const */
let { colorMode = 'light', disabled = false, id = '', invalid = $bindable(false), items, label = '', name, placeholder = '', readonly = false, required = false, validationMessage = '', selectedValues = $bindable([]), class: className = '', ...rest } = $props();
/* eslint-enable prefer-const */
</script>

<SelectField
  {...rest}
  class="MultiSelectField {className}"
  {colorMode}
  {disabled}
  {id}
  {invalid}
  {items}
  {label}
  {name}
  {placeholder}
  {readonly}
  {required}
  {validationMessage}
  bind:selectedValues
  multiSelect
/>

<style>/**
 * Checkbox styling is shared between CheckboxesField and MultiSelectField
 * The biggest difference between the two is the hover/focus/etc states are on different elements, so it cannot just be
 * one big mixin and has to be broken up
 */
@layer design-system-components.pwds {
  :global(.MultiSelectField) :global(.SelectDropdown__option:hover) :global(label:before) {
    box-shadow: inset 0 0 0 var(--checkboxes-field-outer-width) var(--color-form-field-hover);
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option:focus-visible) :global(label:before) {
    box-shadow: inset 0 0 0 var(--checkboxes-field-outer-width) var(--color-form-field-focus);
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option[aria-checked=true]:focus-visible:before) {
    background-color: var(--color-form-field-focus);
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option[aria-checked=true]) :global(label:before) {
    background-color: var(--color-form-field-selected);
    box-shadow: none;
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option[aria-checked=true]) :global(label:after) {
    opacity: 1;
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option) :global(label) {
    position: relative;
    padding-left: calc(var(--checkboxes-field-outer-size) + var(--space-10));
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option) :global(label:before), :global(.MultiSelectField) :global(.SelectDropdown__option) :global(label:after) {
    content: "";
    position: absolute;
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option) :global(label:before) {
    box-shadow: inset 0 0 0 var(--checkboxes-field-outer-width) var(--color-form-field-default);
    top: 0;
    left: 0;
    height: var(--checkboxes-field-outer-size);
    width: var(--checkboxes-field-outer-size);
    border-radius: var(--checkboxes-field-outer-border-radius);
  }
  :global(.MultiSelectField) :global(.SelectDropdown__option) :global(label:after) {
    top: calc((var(--checkboxes-field-outer-size) - var(--checkboxes-field-inner-height)) / 2 - 1px);
    left: calc((var(--checkboxes-field-outer-size) - var(--checkboxes-field-inner-width)) / 2);
    height: var(--checkboxes-field-inner-height);
    width: var(--checkboxes-field-inner-width);
    border-width: 0;
    border-left-width: var(--checkboxes-field-checkmark-width);
    border-bottom-width: var(--checkboxes-field-checkmark-width);
    border-style: var(--border-line-style);
    border-bottom-left-radius: var(--checkboxes-field-checkmark-radius);
    border-color: var(--color);
    opacity: 0;
    filter: invert(100%);
    transform: rotate(-45deg);
  }
}</style>
